<template>
  <div class="bindingEnterprise">
    <Form :model="form" :rules="rules" v-model="regular">
      <SelectInput
        label="企业名称"
        class="temr"
        v-model="form.corpName"
        :reg="rules.corpName"
        @getTaxNo="getTaxNo"
        :maxlength="50"
        labelWidth="90px"
        placeholder="请输入企业名称"
      />
      <Input
        label="企业税号"
        class="temr"
        v-model="form.taxNo"
        :reg="rules.taxNo"
        :maxlength="20"
        :toUpperCase="true"
        labelWidth="90px"
        placeholder="请输入企业税号"
      />
      <div class="van-field_box">
      <Select
        label="我是"
        :maxlength="12"
        v-model="form.type"
        labelWidth="90px"
        placeholder="请输入"
      />
      </div>
      <div class="cell">
        <Input
          label="姓名"
          class="temr"
          v-model="publicPage.userName"
          :readonly="true"
          labelWidth="90px"
          placeholder="请输入手机号"
        />
      </div>

      <Input
        label="身份证号"
        class="temr"
        v-model="publicPage.identity"
        :readonly="true"
        labelWidth="90px"
        placeholder="请输入身份证号"
      />
      <Input
        label="手机号"
        class="temr"
        v-model="publicPage.phone"
        :maxlength="11"
        :readonly="true"
        labelWidth="90px"
        placeholder="请输入手机号"
      />
      <div class="Contract">
        <Contract
          text="本人已经阅读并完全同意"
          :list="contractList"
          v-model="form.isAgree"
        />
      </div>
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="提交"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { rules } from '@/utils';
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Contract from '@/components/Contract.vue';
import Select from './components/Select.vue';
import SelectInput from './components/SelectInput.vue';

export default {
  name: 'bindingEnterprise',
  data() {
    return {
      fillData:{},
      form: {
        userName: '',
        phone: '',
        identity: '',
        type: '1',
        corpName: '',
        taxNo: '',
        isAgree: true,
      },
      rules: {
        corpName: rules.companyNameForBindingCompany,
        taxNo: rules.taxNoForBindingCompany,
        type: rules.type,
      },
      loading: false,
      regular: false,
      contractList: [
        {
          text: '授权承诺书',
          value: 'bw_sq',
        },
      ],
    };
  },
  provide() {
    return {
      bindUserRoot: this,
    };
  },
  components: {
    Form,
    Input,
    Select,
    Button,
    Contract,
    SelectInput,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getUserInfo();
    this.getUserInfoPlaintext();
  },
  methods: {
    // 获取用户信息明文
    getUserInfoPlaintext() {
      this.$api.PublicPage.getUserPhone().then((res) => {
        const { data } = res;
        this.fillData = {
          borrowerName: data.userName,
          borrowerIdentity: data.identity,
        };
      });
    },
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),
    nextStep() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      this.form = {
        ...this.form,
        userName: this.publicPage.userName,
        phone: this.publicPage.phone,
        identity: this.publicPage.identity,
      };
      delete this.form.isAgree;
      this.$api.PublicPage.submitCertification(this.form).then((res) => {
        if (res.success) {
          this.$toast.clear();
          this.$toast.success('操作成功');
          this.$router.push(localStorage.getItem('returnPage'));
        } else {
          this.$toast.fail(res.returnMessage);
        }
      });
    },
    getTaxNo(e) {
      this.form = {
        ...this.form,
        taxNo: e,
      };
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 20px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.passwordBox {
  position: relative;
}
.showPassword {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 17px;
  right: 18px;
  background: #fff;
}
.showPassword img {
  width: 100%;
  height: 100%;
}
.bindingEnterprise >>> .passwordBox input {
  width: 100% !important;
}
.bindingEnterprise >>> .Input {
  padding: 16px;
}
.bindingEnterprise >>> .Input input {
  font-size: 15px !important;
}
.Contract {
  margin-top: 12px;
}
.cell {
  margin-top: 8px;
}
.van-field_box >>> .van-field__label{
  margin-right: 0px;
}
</style>
